import { render, staticRenderFns } from "./listCourses.vue?vue&type=template&id=2f527866&"
import script from "./listCourses.vue?vue&type=script&lang=js&"
export * from "./listCourses.vue?vue&type=script&lang=js&"
import style0 from "./listCourses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports